export const statuses = ["DRAFT", "SENT", "PAID", "DUE", "ARCHIVED"];

// TODO: get currencies and conversion rates from an API
export const currencies = [
  { id: "EUR", name: "Euro", symbol: "€" },
  { id: "USD", name: "US Dollar", symbol: "$" },
  { id: "GBP", name: "British Pound", symbol: "£" },
  { id: "CHF", name: "Swiss Franc", symbol: "CHF" },
  { id: "CAD", name: "Canadian Dollar", symbol: "CA$" },
  { id: "AUD", name: "Australian Dollar", symbol: "AU$" },
  { id: "YEN", name: "Japanese Yen", symbol: "¥" },
  { id: "JPY", name: "Japanese Yen", symbol: "¥" },
  { id: "NZD", name: "New Zealand Dollar", symbol: "NZ$" },
  { id: "SEK", name: "Swedish Krona", symbol: "kr" },
  { id: "CNH", name: "Chinese Yuan", symbol: "CN¥" },
  { id: "PLN", name: "Polish Zloty", symbol: "zł" },
  { id: "AED", name: "UAE Dirham", symbol: "AED" },
  { id: "SGD", name: "Singapore Dollar", symbol: "SGD" },
  { id: "HUF", name: "Hungarian Forint", symbol: "Ft" },
  { id: "RON", name: "Romanian Leu", symbol: "RON" },
  { id: "KRW", name: "South Korean Won", symbol: "₩" },
  { id: "TRY", name: "Turkish Lira", symbol: "₺" },
  { id: "RSD", name: "Serbian Dinar", symbol: "RSD" },
  { id: "BAM", name: "Bosnia-Herzegovina Convertible Mark", symbol: "BAM" },
  { id: "XOF", name: "West African CFA Franc", symbol: "CFA" },
  { id: "BRL", name: "Brazilian Real", symbol: "R$" },
  { id: "MAD", name: "Moroccan Dirham", symbol: "MAD" },
  { id: "VND", name: "Vietnamese Dong", symbol: "₫" },
  { id: "MYR", name: "Malaysian Ringgit", symbol: "RM" },
];

export const phoneIndicatifs = [
  { id: "+43", name: "AT", flag: "🇦🇹", placeholder: "664 123456", countryNameFr: "Autriche", countryNameEn: "Austria" },
  { id: "+32", name: "BE", flag: "🇧🇪", placeholder: "470 12 34 56", countryNameFr: "Belgique", countryNameEn: "Belgium" },
  { id: "+359", name: "BG", flag: "🇧🇬", placeholder: "87 123 4567", countryNameFr: "Bulgarie", countryNameEn: "Bulgaria" },
  { id: "+41", name: "CH", flag: "🇨🇭", placeholder: "78 123 45 67", countryNameFr: "Suisse", countryNameEn: "Switzerland" },
  { id: "+357", name: "CY", flag: "🇨🇾", placeholder: "96 123456", countryNameFr: "Chypre", countryNameEn: "Cyprus" },
  { id: "+420", name: "CZ", flag: "🇨🇿", placeholder: "601 123 456", countryNameFr: "République tchèque", countryNameEn: "Czech Republic" },
  { id: "+49", name: "DE", flag: "🇩🇪", placeholder: "151 12345678", countryNameFr: "Allemagne", countryNameEn: "Germany" },
  { id: "+34", name: "ES", flag: "🇪🇸", placeholder: "612 345 678", countryNameFr: "Espagne", countryNameEn: "Spain" },
  { id: "+372", name: "EE", flag: "🇪🇪", placeholder: "5123 456", countryNameFr: "Estonie", countryNameEn: "Estonia" },
  { id: "+358", name: "FI", flag: "🇫🇮", placeholder: "40 123 4567", countryNameFr: "Finlande", countryNameEn: "Finland" },
  { id: "+33", name: "FR", flag: "🇫🇷", placeholder: "6 43 67 97 11", countryNameFr: "France", countryNameEn: "France" },
  { id: "+30", name: "GR", flag: "🇬🇷", placeholder: "691 234 5678", countryNameFr: "Grèce", countryNameEn: "Greece" },
  { id: "+385", name: "HR", flag: "🇭🇷", placeholder: "91 234 5678", countryNameFr: "Croatie", countryNameEn: "Croatia" },
  { id: "+36", name: "HU", flag: "🇭🇺", placeholder: "20 123 4567", countryNameFr: "Hongrie", countryNameEn: "Hungary" },
  { id: "+353", name: "IE", flag: "🇮🇪", placeholder: "85 123 4567", countryNameFr: "Irlande", countryNameEn: "Ireland" },
  { id: "+39", name: "IT", flag: "🇮🇹", placeholder: "312 345 6789", countryNameFr: "Italie", countryNameEn: "Italy" },
  { id: "+423", name: "LI", flag: "🇱🇮", placeholder: "660 1234", countryNameFr: "Liechtenstein", countryNameEn: "Liechtenstein" },
  { id: "+370", name: "LT", flag: "🇱🇹", placeholder: "612 34567", countryNameFr: "Lituanie", countryNameEn: "Lithuania" },
  { id: "+352", name: "LU", flag: "🇱🇺", placeholder: "628 123 456", countryNameFr: "Luxembourg", countryNameEn: "Luxembourg" },
  { id: "+371", name: "LV", flag: "🇱🇻", placeholder: "21 123 456", countryNameFr: "Lettonie", countryNameEn: "Latvia" },
  { id: "+377", name: "MC", flag: "🇲🇨", placeholder: "6 12 34 56 78", countryNameFr: "Monaco", countryNameEn: "Monaco" },
  { id: "+356", name: "MT", flag: "🇲🇹", placeholder: "7912 3456", countryNameFr: "Malte", countryNameEn: "Malta" },
  { id: "+31", name: "NL", flag: "🇳🇱", placeholder: "6 12345678", countryNameFr: "Pays-Bas", countryNameEn: "Netherlands" },
  { id: "+48", name: "PL", flag: "🇵🇱", placeholder: "512 345 678", countryNameFr: "Pologne", countryNameEn: "Poland" },
  { id: "+351", name: "PT", flag: "🇵🇹", placeholder: "912 345 678", countryNameFr: "Portugal", countryNameEn: "Portugal" },
  { id: "+386", name: "SI", flag: "🇸🇮", placeholder: "31 234 567", countryNameFr: "Slovénie", countryNameEn: "Slovenia" },
  { id: "+421", name: "SK", flag: "🇸🇰", placeholder: "912 345 678", countryNameFr: "Slovaquie", countryNameEn: "Slovakia" },
  { id: "+90", name: "TR", flag: "🇹🇷", placeholder: "532 123 4567", countryNameFr: "Turquie", countryNameEn: "Turkey" },
  { id: "+380", name: "UA", flag: "🇺🇦", placeholder: "50 123 4567", countryNameFr: "Ukraine", countryNameEn: "Ukraine" },
  { id: "+971", name: "AE", flag: "🇦🇪", placeholder: "50 123 4567", countryNameFr: "Émirats arabes unis", countryNameEn: "United Arab Emirates" },
  { id: "+44", name: "UK", flag: "🇬🇧", placeholder: "7911 123456", countryNameFr: "Royaume-Uni", countryNameEn: "United Kingdom" },
  { id: "+1", name: "US", flag: "🇺🇸", placeholder: "123 456 7890", countryNameFr: "États-Unis", countryNameEn: "United States" },
];

export const PRICING_FEATURES = {
  starter: {
    userLimit: 1,
    bankLimit: 1,
    aiCopilot: false,
    stripeConnect: false,
    customInvoice: false,
    sendInvoiceByEmail: false,
    paymentLink: false,
    emailImport: false,
    // DASHBOARD
    cashFlowDashboard: false,
    profitAndLossDashboard: false,
  },
  lite: {
    userLimit: 9999,
    bankLimit: 9999,
    aiCopilot: true,
    stripeConnect: true,
    customInvoice: false,
    sendInvoiceByEmail: false,
    paymentLink: false,
    emailImport: false,
    // DASHBOARD
    cashFlowDashboard: false,
    profitAndLossDashboard: false,
  },
  business: {
    userLimit: 9999,
    bankLimit: 9999,
    aiCopilot: true,
    stripeConnect: true,
    customInvoice: true,
    sendInvoiceByEmail: true,
    paymentLink: true,
    emailImport: true,
    // DASHBOARD
    cashFlowDashboard: true,
    profitAndLossDashboard: true,
  },
  free: {
    userLimit: 9999,
    bankLimit: 9999,
    aiCopilot: true,
    stripeConnect: true,
    customInvoice: true,
    sendInvoiceByEmail: true,
    paymentLink: true,
    emailImport: true,
    // DASHBOARD
    cashFlowDashboard: true,
    profitAndLossDashboard: true,
  },
};
